import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export const api = {
  getConfig: () => client.get("/config").then((r) => r.data),
  getProducts: (params = {}) => client.get("/products", { params }).then((r) => r.data),
  getProduct: (handle) => client.get(`/products/${handle}`).then((r) => r.data),
  getCollections: () => client.get("/collections").then((r) => r.data),
  getBrand: (brand) => client.get(`/brands/${brand}`).then((r) => r.data),
  getReviews: () => client.get("/reviews").then((r) => r.data),
  getMenu: () => client.get("/menu").then((r) => r.data),
  getCollection: (handle, params = {}) => client.get(`/collections/${handle}/products`, { params }).then((r) => r.data),
  getPolicies: () => client.get("/policies").then((r) => r.data),
  getPolicy: (handle) => client.get(`/policies/${handle}`).then((r) => r.data),

  createCart: () => client.post("/cart").then((r) => r.data),
  getCart: (id) => client.get(`/cart/${id}`).then((r) => r.data),
  addToCart: (id, line) => client.post(`/cart/${id}/add`, line).then((r) => r.data),
  addManyToCart: (id, lines) => client.post(`/cart/${id}/add-many`, { lines }).then((r) => r.data),
  updateCart: (id, line) => client.post(`/cart/${id}/update`, line).then((r) => r.data),
  removeCart: (id, line) => client.post(`/cart/${id}/remove`, line).then((r) => r.data),
  getSuggestions: (id) => client.get(`/cart/${id}/suggestions`).then((r) => r.data),
  checkout: (id) => client.post(`/cart/${id}/checkout`).then((r) => r.data),

  quizRecommend: (answers) => client.post("/quiz/recommend", answers).then((r) => r.data),
  recoveryRecommend: (answers) => client.post("/recovery-builder/recommend", answers).then((r) => r.data),
  postWhiteGlove: (data) => client.post("/white-glove", data).then((r) => r.data),
  postConsultation: (data) => client.post("/consultation", data).then((r) => r.data),
  postCommercial: (data) => client.post("/commercial-quote", data).then((r) => r.data),
  postNewsletter: (email) => client.post("/newsletter", { email }).then((r) => r.data),
  postQuote: (data) => client.post("/quote-request", data).then((r) => r.data),
};
